type RawSchemaNode = {
  id?: string;
  category?: string;
  children?: RawSchemaNode | RawSchemaNode[];
};

const isRawSchemaNode = (value: unknown): value is RawSchemaNode =>
  typeof value === 'object' && value !== null;

const isSimpleMultivalue = (node: RawSchemaNode): boolean =>
  node.category === 'multivalue' &&
  isRawSchemaNode(node.children) &&
  !Array.isArray(node.children) &&
  node.children.category === 'datapoint';

const isTableMultivalue = (node: RawSchemaNode): boolean =>
  node.category === 'multivalue' &&
  isRawSchemaNode(node.children) &&
  !Array.isArray(node.children) &&
  node.children.category === 'tuple';

const buildPathMap = (
  items: unknown[],
  parentPath: string,
  result: Map<string, string>
): void => {
  items.forEach(item => {
    if (!isRawSchemaNode(item) || !item.id) return;

    const isSimple = isSimpleMultivalue(item);
    const isTable = isTableMultivalue(item);
    const isSection = item.category === 'section';

    const nodeId = isSimple ? (item.children as RawSchemaNode).id : item.id;

    if (!nodeId) return;

    const currentPath = parentPath ? `${parentPath}/${nodeId}` : nodeId;
    result.set(nodeId, currentPath);

    if (isSection && Array.isArray(item.children)) {
      buildPathMap(item.children, currentPath, result);
    } else if (isTable && isRawSchemaNode(item.children)) {
      const tuple = item.children;
      if (tuple.children && Array.isArray(tuple.children)) {
        buildPathMap(tuple.children, currentPath, result);
      }
    }
  });
};

export const getIdToPathMap = (schemaContent: unknown): Map<string, string> => {
  const result = new Map<string, string>();

  if (!Array.isArray(schemaContent)) {
    return result;
  }

  buildPathMap(schemaContent, '', result);
  return result;
};
